module.exports = __webpack_public_path__ + "img/dc-actions-en.d1e5a40a.png";